<main>
  <div class="empty">
    <img src="assets/images/turma-empty.png" alt="">
    <span>Nenhum dado encontrado !</span>
  </div>
</main>
